import { HttpClient } from "@angular/common/http";
import { UtilsService } from "./utils.service";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import {  map } from "rxjs/operators";
import { ResponseKrypto } from "../settings/interfaces/krypto";
import { Injectable } from "@angular/core";

const API_KRYPTO = environment.api.urlCoreAdmin;
@Injectable({
    providedIn: 'root'
})
export class KryptoService {

    constructor(private http: HttpClient, private utilService: UtilsService) { }

    getKryptos(params?: any): Observable<ResponseKrypto> {
        const url = `${API_KRYPTO}/v1/krypto/keys${this.utilService.getParams(params)}`;
        return this.http.get(url).pipe(
            map((res: ResponseKrypto) => {
                return res;
            }));
    }

    createKrypto(data: any) {
        const url = `${API_KRYPTO}/v1/krypto/generate/init/key`;
        return this.http.post(url, data).pipe(
            map((res: any) => {
                return res;
            }));
    }

    assingKey(email: string, key: number) {
        const url = `${API_KRYPTO}/v1/krypto/assign/key/${key}`;
        const body = { guestEmail: email };
        return this.http.post(url, body).pipe(
            map((res: any) => res)
        );
    }

    keyById(id: string) {
        const url = `${API_KRYPTO}/v1/krypto/key/${id}`;
        return this.http.get(url);
    }

    generatePartialKey(key: string, password: string) {
        const url = `${API_KRYPTO}/v1/krypto/generate/partial/key/${key}`;
        const body = { Password: password };
        return this.http.post(url, body).pipe(
            map((res: any) => res)
        );
    }

    generateKey(key: string) {
        const url = `${API_KRYPTO}/v1/krypto/generate/key/${key}`;
        return this.http.post(url, null).pipe(
            map((res: any) => res)
        );
    }

    deprecateKey(key: string) {
        const url = `${API_KRYPTO}/v1/krypto/deprecate/key/${key}`;
        return this.http.post(url, null).pipe(
            map((res: any) => res)
        );
    }

    validateCustodio(email: string) {
        const url = `${API_KRYPTO}/v1/krypto/validate/custodio`;
        const body = { guestEmail: email }
        return this.http.post(url, body).pipe(
            map((res: any) => res)
        );
    }


}